import { Component } from '@angular/core';

@Component({
  selector: 'app-device-choice-modal',
  standalone: true,
  imports: [],
  templateUrl: './device-choice-modal.component.html',
  styleUrl: './device-choice-modal.component.scss'
})
export class DeviceChoiceModalComponent {

}
